import { useEffect, useState } from 'react';
import { Button } from '@mela/design-system';
import { safeGet, safeSet } from '../lib/storage';

const KEY = 'mela.cookie.consent';

export function CookieBanner() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!safeGet(KEY)) setShown(true);
  }, []);

  if (!shown) return null;

  function decide(value: 'accepted' | 'rejected') {
    safeSet(KEY, JSON.stringify({ value, at: new Date().toISOString() }));
    setShown(false);
  }

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:w-[440px] z-[200] bg-white border border-ink-200 shadow-floating rounded-xl p-5 animate-fade-up"
    >
      <div className="font-display text-[16px] font-bold text-ink-900 mb-1.5">Cookies & DPDP</div>
      <p className="text-[13px] text-ink-600 leading-snug mb-4">
        We use only essential cookies (session, security) by default. With your consent we add
        analytics to improve the product. You can change this any time at{' '}
        <a href="/about#privacy" className="underline decoration-dotted underline-offset-2 text-ink-800">
          /about#privacy
        </a>
        .
      </p>
      <div className="flex gap-2">
        <Button variant="primary" size="sm" className="flex-1" onClick={() => decide('accepted')}>
          Accept all
        </Button>
        <Button variant="outline" size="sm" className="flex-1" onClick={() => decide('rejected')}>
          Essential only
        </Button>
      </div>
    </div>
  );
}
